<style lang="scss" type="text/scss">
  .stat :global(.button) {
    background: #eee;
    padding: 16px;
    border-radius: 4px;
    margin: 0;
    font-family: proxima-nova, sans-serif;
    font-weight: 500;
    color: #4c4c4b;
    font-size: 14px;
  }

  .stat-darker {
    padding: 16px;
    margin: 16px;
  }

  .pending {
    background: #39ad48;
  }

  .pending h3 {
    color: #fff;
  }

  div.attendee h3 {
    color: #ff6452;
  }
</style>

<script>
  import {getContext} from 'svelte';
  import AppLink from '../../../utils/link';
  import Card from '../../../components/containers/card.html';
  import Avatar from '../../../components/containers/avatar.html';
  import {addNotification, ICONS} from '../../../utils/notifications.store';
  import moment from 'moment';
  export let attendee;
  export let waitlist;
  export let event;
  let people = attendee.people;
  import {MOVE_FROM_WAITLIST, EVENT_ATTENDEES, RELEASE_WAITLIST} from '../../../graphql/events';

  const client = getContext('apollo');

  function move() {
    addNotification({
      message: `Are you sure you want to move the ${attendee.household.primary.person.lastName} Household from the waitlist to attendees?`,
      icon: ICONS.CONFIRM,
      confirm: confirmMove 
    })
  }

  async function confirmMove() {
    try {
      await client.mutate({mutation: MOVE_FROM_WAITLIST, variables: {id: attendee.id}, refetchQueries: [
        {query: EVENT_ATTENDEES, variables:{waitlist: true, id: event }}
      ]})

      addNotification({
        message: `Moved ${attendee.household.primary.person.lastName} Household from the waitlist to attendees`,
        icon: ICONS.SUCCESS,
        time: 3000
      })
    
    } catch (e) {
      addNotification({
        message: `There was an error moving ${attendee.household.primary.person.lastName} Household from the waitlist to attendees`,
        icon: ICONS.ERROR,
        time: 3000
      })
    }
  }

  function release() {
    addNotification({
      message: `Are you sure you want to release the ${attendee.household.primary.person.lastName} Household from the waitlist? Doing so will notify ${attendee.household.primary.person.lastName} to claim available spots.`,
      icon: ICONS.CONFIRM,
      confirm: confirmRelease
    })
  }

  async function confirmRelease() {
    try {
      await client.mutate({mutation: RELEASE_WAITLIST, variables: {input:{registrations:[attendee.id]}}, refetchQueries: [
        {query: EVENT_ATTENDEES, variables:{waitlist: true, id: event }}
      ]})

      addNotification({
        message: `Released ${attendee.household.primary.person.lastName} Household from the waitlist`,
        icon: ICONS.SUCCESS,
        time: 3000
      })
    
    } catch (e) {
      addNotification({
        message: `There was an error releasing ${attendee.household.primary.person.lastName} Household from the waitlist`,
        icon: ICONS.ERROR,
        time: 3000
      })
    }
  }
</script>

<Card>
  <div class:attendee class:pending={attendee.status === 'PendingWaitlistConfirmation'}>
  <div class="grid-x grid-margin-x" >
    <div class="cell small-8">
      <AppLink href="{`/households/view/${attendee.household.id}`}">
        <h3 class="u--padall u--primary">{attendee.household.primary.person.lastName} Household</h3>
      </AppLink>
    </div>
    <div class="cell small-4">
   
          {#if waitlist}
        {#if attendee.status === 'PendingWaitlistConfirmation'}
          <div class="text-right">
            <h3 class="u--padall">Pending Confirmation</h3>
          </div>

        {:else if attendee.status === 'WaitlistConfirmationNo'} 
        <div class="text-right" style="display: flex;justify-content: flex-end;align-items: center; padding: 0 10px;height: 100%;">
          <div  class="button small secondary" style="margin-bottom:0;background:transparent;color:#ff6452">
            Declined Waitlist Spot
          </div>
        </div>
        {:else}
        <div class="text-right" style="display: flex;justify-content: flex-end;align-items: center; padding: 0 10px;height: 100%;">
          <div on:click="{(e => release())}" class="button small secondary" style="margin-bottom:0;">
            Release from Waitlist
          </div>
        </div>
      {/if}
      {/if}
      
    </div>
  </div>
  </div>
  
  <hr />

  
  <div class="stat-darker">
    <div class="grid-x grid-margin-x small-up-12 medium-up-2">
      {#each people as person, i}
        <div class="cell">
          <Card>
            <div class="u--padall">
              <div class="grid-x">
                <div class="small-12 medium-2">
                  <Avatar photo={person.avatar} />
                </div>
                <div class="small-12 medium-10">
                  <h3>{person.firstName} {person.lastName}</h3>
                  <h4>{person.relationship}</h4>
                </div>
              </div>
            </div>
          </Card>
        </div>
      {/each}
    </div>
  </div>
  
  <div class="stat">
    <div class="grid-x">
      <div class="cell small-12 medium-2">
        <h4>DONATION</h4>
        <h5>${attendee.donationAmount !== 'NULL' && attendee.donationAmount !== null ? attendee.donationAmount : 0}</h5>
      </div>
      <div class="cell small-12 medium-6">
        <h4>REGISTRATION DATE</h4>
        <h5>{moment(attendee.createdAt).format('dddd, MMMM Do, YYYY h:mm A')}</h5>
      </div>
      <div class="cell small-12 medium-4 text-right">
        {#if waitlist}
        <div on:click="{move}" class="button">
          MOVE TO ATTENDEES
        </div>
        {/if}
        <!--<div class="button">
          Cancel Registration
        </div>-->
      </div>
    </div>
  </div>
</Card>